import axios from 'axios';
import qs from 'qs';
import {
  ECPAY_API_PATH,
} from '@/api/path';

export const userRequest = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  withCredentials: process.env.NODE_ENV === 'development' ? false : true,
});
export const postFunc = (path, data) => userRequest.post(`${ ECPAY_API_PATH }${ path }`, qs.stringify(data));

export const getFunc = path => userRequest.get(`${ ECPAY_API_PATH }${ path }`);

export const getECPayToken = async(data) => await postFunc('/getECPayToken.php', data);

export const createECPayTransaction = async(data) => await postFunc('/createECPayTransaction.php', data);
